import Splide from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", function () {
	const blocks = document.querySelectorAll(".staff-testimonial-block");

	if (!blocks.length) return;

	blocks.forEach(function (block) {
		const slider = block.querySelector(".testimonial-slider.splide");
		if (!slider) return;

		const splide = new Splide(slider, {
			type: "loop",
			perPage: 1,
			perMove: 1,
			gap: "2.4rem",
			arrows: false,
			pagination: false,
			autoplay: false,
			mediaQuery: "min",
			breakpoints: {
				992: {
					perPage: 2,
				},
			},
		}).mount();

		const prevBtn = block.querySelector(".staff-testimonial-arrow.-prev");
		const nextBtn = block.querySelector(".staff-testimonial-arrow.-next");

		if (prevBtn && nextBtn) {
			prevBtn.addEventListener("click", function () {
				splide.go("<");
			});

			nextBtn.addEventListener("click", function () {
				splide.go(">");
			});
		}
	});
});
